import { forwardRef, useRef } from 'react';
import { Textarea } from '@/app/components/ui/textarea';
import type { TextAreaFieldProps } from '@/app/types';
import { cn } from '@/app/utils';

export const TextAreaField = forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(
  (
    {
      onChange,
      placeholder,
      label,
      readOnly = false,
      className,
      labelClassName,
      fieldClassName,
      rows,
      initialValue,
      maxLength,
      required,
      errorMsg,
      checkChangeOnBlur,
      showRequired,
    },
    ref,
  ) => {
    const changeRef = useRef(false);

    return (
      <div className={className}>
        {(label || errorMsg) && (
          <div className={cn('mb-2 flex text-white text-xs', labelClassName)}>
            {showRequired && required && <span className="mr-1 text-system-danger">*</span>}
            {label}
            {errorMsg && <div className="ml-2 text-system-danger">{errorMsg}</div>}
          </div>
        )}

        <Textarea
          className={cn(
            'resize-none border-none bg-system-black36 p-3 text-white leading-5 placeholder:text-system-white36',
            fieldClassName,
          )}
          defaultValue={initialValue}
          rows={rows}
          readOnly={readOnly}
          ref={ref}
          onChange={(e) => {
            onChange?.(e);
            changeRef.current = true;
          }}
          placeholder={placeholder}
          maxLength={maxLength}
          required={required}
          onBlur={() => {
            checkChangeOnBlur?.(changeRef.current);
            changeRef.current = false;
          }}
        />
      </div>
    );
  },
);

TextAreaField.displayName = 'TextAreaField';
